module.exports = __webpack_public_path__ + "static/media/about-2.ddfa4ba0.jpeg";